import {Injectable, Component} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CandidatureFormationService} from './candidature-formation.service';
import {CandidatureFormation} from './candidature-formation.model';

@Injectable()
export class CandidaturePopupService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private candidatureFormationService: CandidatureFormationService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.candidatureFormationService.find(id, false).subscribe(candidatureFormation => {
                this.candidatureModalRef(component, candidatureFormation);
            });
        } else {
            return this.candidatureModalRef(component, new CandidatureFormation());
        }
    }

    candidatureModalRef(component: Component, candidatureFormation: CandidatureFormation): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.candidatureFormation = candidatureFormation;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-popup.service.ts